import React, { useState, useEffect, useRef } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import { FaPen, FaPlus, FaSearch, FaThumbsUp, FaFileInvoiceDollar, FaHotel, FaLayerGroup, FaUserTie, FaPaperPlane, FaRedo, FaSyncAlt, FaClipboardCheck, FaFilter, FaTimes, FaEnvelope } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { ImCancelCircle } from 'react-icons/im';
import TabelaLoading from '../../components/TabelaLoading';
import api from '../../services/api';
import Alert from '../../components/Alert';
import AlertaSedes from '../../components/AlertaSedes';
import { FinField, FinCheck, FinChecks, FinTextarea } from '../../components/FinField';
import ReactSelect from '../../components/ReactSelect';
import { Link, useLocation, useHistory } from 'react-router-dom';
import '../../css/financeiro-parcela-pagar.css';

// Filtros avançados com valor fixo. `todos` é sentinela da tela: vazio não aparece
// selecionado no ReactSelect, e o back entende vazio como "sem filtro".
const OPCOES_SITUACAO = [
    { value: 'ativo', label: 'Ativos' },
    { value: 'inativo', label: 'Inativos' },
    { value: 'todos', label: 'Todos' },
];
const OPCOES_PREFERENCIAL = [
    { value: 'todos', label: 'Todos' },
    { value: 'sim', label: 'Preferenciais' },
    { value: 'nao', label: 'Não preferenciais' },
];
const doSentinela = (valor) => (valor === 'todos' ? '' : valor);
const paraSentinela = (valor) => (valor ? valor : 'todos');

export default function PainelFornecedor() {
    const token = localStorage.getItem('token');
    const perfil = localStorage.getItem("perfil");

    // Mesma lista do back (FornecedorDisparoController::PERFIS_DISPARO). Vale para o disparo
    // em massa e para os links do disparo e da revisão. O `suplier` é a área de Fornecedores
    // e entra, no Excluir também.
    const podeDisparar = ['admin', 'diretor', 'gerenteprojeto', 'gerentefinanceiro', 'suplier'].includes(perfil);
    // Mesma lista do back (FornecedorGrupoController::PERFIS_SEM_TELA_GRUPO): para esses perfis o
    // cadastro do grupo responde 403, então o nome do grupo fica em texto.
    const podeVerGrupo = !['backofficeinterno', 'criacao', 'aereo'].includes(perfil);

    // Nome do grupo na coluna Grupo: leva ao cadastro dele.
    const linkGrupo = (grupo) => (podeVerGrupo
        ? <Link to={'/cadastroFornecedorGrupo/' + grupo.id} title="Abrir o cadastro do grupo">{grupo.nome}</Link>
        : grupo.nome);
    const [filtro, setFiltro] = useState({
        // Busca única: o `nome` do back já procura em nome, nome fantasia, código, CNPJ e CPF.
        nome: '',
        // Situação é EIXO, não constante. Já esteve fixa em 'ativo' para alinhar a
        // lista ao recorte do disparo, e isso sumiu com o fornecedor inativo: a tela
        // não tinha por onde trazê-lo de volta, e a coluna Situação — que existe
        // desde antes, com pill própria para "não ativo" — passou a imprimir "ativo"
        // em 100% das linhas. Cadastro precisa mostrar o que está desligado, senão
        // não dá para religar. Abre em 'ativo', que preserva o comportamento de
        // sempre.
        situacaoRegistro: 'ativo',
        // '' = todos; 'sim' / 'nao' viram filtro no back (o "não" inclui quem está sem valor).
        preferencial: '',
        // Rede: ids dos grupos, pela tabela de vínculo (quem está em mais de um grupo aparece em cada).
        fornecedorGrupo: [],
        // Com dois grupos ou mais: só quem está em todos eles, em vez de quem está em qualquer um.
        fornecedorGrupoTodos: false,
    });
    // Grupos filtrados com o nome ({ value, label }) — só para o modal e a pílula; não vão ao servidor.
    const [gruposFiltro, setGruposFiltro] = useState([]);
    // Chave de dependência dos efeitos: o array muda de referência a cada "Aplicar".
    const chaveGrupos = filtro.fornecedorGrupo.join(',');
    // Mais filtros: o modal edita um rascunho, que só vale no "Aplicar filtros".
    const [mostrarFiltros, setMostrarFiltros] = useState(false);
    // Modal Cópias de e-mail: null fechado; aberto, o texto de cada campo como a pessoa digita.
    const [copias, setCopias] = useState(null);
    const [salvandoCopias, setSalvandoCopias] = useState(false);
    const [rascunho, setRascunho] = useState(null);
    const [buscando, setBuscando] = useState(false);
    const [fornecedores, setFornecedores] = useState([]);

    // Contadores vêm de endpoint próprio: a listagem é limitada a 1000 registros,
    // então contar em cima do que voltou daria número errado num tenant de 3 mil.
    const [contadoresDisparo, setContadoresDisparo] = useState(null);
    let { state } = useLocation();
    const history = useHistory();
    const tipoCadastro = state?.tipoCadastro ?? 'fornecedor';

    // Paginação e seleção
    const [selectedIds, setSelectedIds] = useState(new Set());
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(15);

    // Ordem pedida ao servidor: ordenar só a página traria a ordem errada a partir da 2ª.
    // `campo` vazio é a ordem padrão do back (preferenciais primeiro, depois nome).
    const [ordem, setOrdem] = useState({ campo: '', dir: 'asc' });

    // Total vindo do SERVIDOR. Antes era `fornecedores.length`, que com o teto de
    // 1000 do `index` dizia "1.000 registros" num tenant de 3.077 — e o chip ao lado,
    // que conta com COUNT(*) sem teto, dizia 3.004. Não era página seguinte: os 2.004
    // nunca chegavam.
    const [totalServidor, setTotalServidor] = useState(0);

    // Bump manual para o form de busca por texto forçar refetch mesmo quando nada
    // nas dependências mudou (buscar por outro nome com a página já em 1).
    const [recarga, setRecarga] = useState(0);
    const controllerRef = useRef(null);

    const toggleSelect = id => setSelectedIds(prev => {
        const n = new Set(prev);
        n.has(id) ? n.delete(id) : n.add(id);
        return n;
    });
    // Compara contra A PÁGINA, não contra o total selecionado. `selectedIds.size ===
    // paginados.length` marcava o cabeçalho da página 2 só porque havia 15 marcados
    // na página 1 — e clicar nele apagava a seleção inteira. Era inofensivo enquanto
    // a seleção só habilitava o "Excluir" (que exige exatamente 1); agora ela
    // alimenta disparo de e-mail.
    const paginaToda = () => paginados.length > 0 && paginados.every(r => selectedIds.has(r.id));

    const toggleAll = () => setSelectedIds(prev => {
        const n = new Set(prev);
        const marcarTudo = !paginaToda();

        paginados.forEach(r => (marcarTudo ? n.add(r.id) : n.delete(r.id)));
        return n;
    });

    const total = totalServidor;
    const totalPaginas = Math.max(1, Math.ceil(total / pageSize));
    // O servidor já devolve só a página pedida — fatiar de novo aqui esconderia
    // registros que ele mandou.
    const paginados = fornecedores;
    const selectedArr = [...selectedIds];

    // Mesmo clique do painel de participantes: a 1ª vez ordena crescente, a seguinte inverte.
    // Volta para a 1ª página; a seleção fica, porque o recorte não muda.
    const ordenarPor = (campo) => {
        setOrdem(atual => (atual.campo === campo
            ? { campo, dir: atual.dir === 'asc' ? 'desc' : 'asc' }
            : { campo, dir: 'asc' }));
        setPage(1);
    };
    const seta = (campo) => (ordem.campo === campo ? (ordem.dir === 'asc' ? ' ▲' : ' ▼') : '');

    const buscar = () => {
        if (controllerRef.current) controllerRef.current.abort();
        controllerRef.current = new AbortController();
        setBuscando(true);

        // A seleção NÃO é descartada aqui: com paginação no servidor, trocar de
        // página é uma busca nova, e limpar a seleção a cada página tornaria
        // impossível marcar registros de páginas diferentes. Quem descarta é o efeito
        // de troca de filtro, logo abaixo — que é o caso em que os ids marcados
        // deixam de estar no recorte.
        // Buscar apenas fornecedores (excluir hotéis)
        const tiposCadastro = ['orcamento'];
        api({
            method: 'get',
            action: '/participante',
            token: token,
            params: {
                ...filtro,
                tipoCadastro: tiposCadastro,
                // relações que esta tela lê (o endpoint só carrega o que for declarado)
                // `fornecedorgrupos.sedes` acende o aviso de rede com mais de uma sede
                include: 'enderecomunicipio,evento,fornecedorgrupo,fornecedorgrupos,fornecedorgrupos.sedes',
                // `situacaoRegistro` chega pelo `...filtro` acima, NÃO fixo em 'ativo'.
                //
                // Fixá-lo alinhava a lista aos chips, mas ao custo de sumir com o
                // fornecedor inativo de uma tela que sempre o mostrou — regressão numa
                // tela que já existia. O filtro passou a ser um select (Ativos /
                // Inativos / Todos) e os chips só aparecem na faixa 'ativo', que é o
                // recorte em que eles fazem sentido. Vazio ("Todos") não vira `where`:
                // o back só filtra com !empty().
                // Épico 0 — Painel Fornecedor com info fiscal
                incluir_classificacao_fiscal: true,
                // Status do formulário de cadastro, derivado dos envios
                incluir_status_disparo: true,
                // Paginação no servidor, no contrato que o `index` já tinha: mandar
                // `pageSize` é o que liga o modo paginado, e os metadados voltam ao
                // lado da lista. O endpoint serve outras telas, então a forma só muda
                // para quem pede. Esta tela chegou a mandar `pagina`/`porPagina` de uma
                // implementação paralela que nasceu sem saber desta — ficou a que já
                // estava em produção, que mantém `data` como array cru para os outros
                // ~80 consumidores do endpoint e desempata a ordenação por `id`.
                page: page,
                pageSize: pageSize,
                ...(ordem.campo ? { ordenarPor: ordem.campo, ordenarDir: ordem.dir } : {}),
            },
            signal: controllerRef.current.signal
        })
            .then(response => {
                // `data` é a lista crua e `total` vem ao lado — mesmo formato que o
                // PainelEvento lê. O fallback para o tamanho da lista cobre a resposta
                // sem metadados (chamada não paginada).
                const lista = response.data?.data ?? [];
                setFornecedores(lista);
                setTotalServidor(response.data?.total ?? lista.length);
                setBuscando(false);
            }).catch(err => {
                if (err.code === "ERR_CANCELED" || err.name === "CanceledError") return;
                //console.log(err)
                setBuscando(false);
            });
    };

    const buscarContadores = () => {
        api({ method: 'get', action: '/fornecedor/disparo/statusFornecedores', token })
            .then(response => setContadoresDisparo(response.data?.data ?? null))
            .catch(() => { });
    };

    useEffect(() => { //onload
        document.querySelector("#buscaFornecedor")?.focus(); //autofocus na busca
        // `buscar()` saiu daqui: o efeito de recorte abaixo já roda na montagem, e
        // manter os dois faria duas requisições em toda abertura da tela.
        buscarContadores();
        return () => { if (controllerRef.current) controllerRef.current.abort(); };
    },
        // eslint-disable-next-line
        []);

    // Épico 0 — checkbox "sem classificação fiscal" re-busca automaticamente ao mudar
    // Trocar de RECORTE volta para a primeira página e descarta a seleção: os ids
    // marcados podem não estar mais no resultado, e os botões que a seleção habilita
    // disparam e-mail.
    const primeiroRender = useRef(true);
    useEffect(() => {
        if (primeiroRender.current) {
            primeiroRender.current = false;
            return;
        }
        setSelectedIds(new Set());
        setPage(1);
        // eslint-disable-next-line
    }, [filtro.sem_classificacao_fiscal, filtro.sem_email, filtro.status_disparo, filtro.situacaoRegistro, filtro.preferencial, chaveGrupos, filtro.fornecedorGrupoTodos]);

    // Uma única porta de entrada para a busca — recorte, página ou tamanho de página.
    // Duas portas fariam a montagem disparar duas requisições.
    useEffect(() => {
        buscar();
        return () => { if (controllerRef.current) controllerRef.current.abort(); };
        // eslint-disable-next-line
    }, [page, pageSize, recarga, ordem.campo, ordem.dir, filtro.sem_classificacao_fiscal, filtro.sem_email, filtro.status_disparo, filtro.situacaoRegistro, filtro.preferencial, chaveGrupos, filtro.fornecedorGrupoTodos]);

    // Grupos para o filtro: a mesma lista do cadastro de fornecedor, buscada pelo nome.
    const buscarGrupos = (input) => api({
        method: 'get',
        action: '/fornecedorGrupo',
        token,
        params: { nome: input },
    })
        .then(response => (response.data?.data ?? []).map(grupo => ({ value: String(grupo.id), label: grupo.nome })))
        .catch(() => []);

    const abrirFiltros = () => {
        setRascunho({
            grupos: gruposFiltro,
            fornecedorGrupoTodos: Boolean(filtro.fornecedorGrupoTodos),
            situacaoRegistro: paraSentinela(filtro.situacaoRegistro),
            preferencial: paraSentinela(filtro.preferencial),
            sem_classificacao_fiscal: Boolean(filtro.sem_classificacao_fiscal),
            sem_email: Boolean(filtro.sem_email),
        });
        setMostrarFiltros(true);
    };

    // Limpar volta ao padrão da tela — Situação em Ativos, como ela abre.
    const limparRascunho = () => setRascunho({
        grupos: [], fornecedorGrupoTodos: false, situacaoRegistro: 'ativo', preferencial: 'todos',
        sem_classificacao_fiscal: false, sem_email: false,
    });

    const aplicarFiltros = () => {
        setFiltro({
            ...filtro,
            fornecedorGrupo: rascunho.grupos.map(grupo => grupo.value),
            // Com um grupo só, "todos" e "qualquer um" dão o mesmo recorte — não fica ligado à toa.
            fornecedorGrupoTodos: rascunho.grupos.length > 1 && rascunho.fornecedorGrupoTodos,
            situacaoRegistro: doSentinela(rascunho.situacaoRegistro),
            preferencial: doSentinela(rascunho.preferencial),
            sem_classificacao_fiscal: rascunho.sem_classificacao_fiscal,
            sem_email: rascunho.sem_email,
        });
        setGruposFiltro(rascunho.grupos);
        setMostrarFiltros(false);
    };

    // "A, B ou C" / "A, B e C" — a pílula diz se o recorte é qualquer grupo ou todos eles.
    const juntarNomes = (nomes, conectivo) => (nomes.length > 1
        ? `${nomes.slice(0, -1).join(', ')} ${conectivo} ${nomes[nomes.length - 1]}`
        : nomes.join(''));
    const nomesGrupos = gruposFiltro.map(grupo => grupo.label);

    // O que os filtros avançados estão recortando, em pílula com × — escondidos no modal,
    // eles não teriam como ser vistos da lista.
    const filtrosAtivos = [
        filtro.fornecedorGrupo.length > 0 && {
            chave: 'grupo',
            rotulo: filtro.fornecedorGrupoTodos
                ? `Em todos os grupos: ${juntarNomes(nomesGrupos, 'e')}`
                : `Grupo: ${juntarNomes(nomesGrupos, 'ou')}`,
            limpar: () => { setFiltro({ ...filtro, fornecedorGrupo: [], fornecedorGrupoTodos: false }); setGruposFiltro([]); },
        },
        filtro.situacaoRegistro !== 'ativo' && {
            chave: 'situacao', rotulo: `Situação: ${filtro.situacaoRegistro === 'inativo' ? 'Inativos' : 'Todos'}`,
            limpar: () => setFiltro({ ...filtro, situacaoRegistro: 'ativo' }),
        },
        filtro.preferencial && {
            chave: 'preferencial', rotulo: filtro.preferencial === 'sim' ? 'Preferenciais' : 'Não preferenciais',
            limpar: () => setFiltro({ ...filtro, preferencial: '' }),
        },
        filtro.sem_classificacao_fiscal && {
            chave: 'fiscal', rotulo: 'Sem classificação fiscal',
            limpar: () => setFiltro({ ...filtro, sem_classificacao_fiscal: false }),
        },
        filtro.sem_email && {
            chave: 'email', rotulo: 'Sem e-mail',
            limpar: () => setFiltro({ ...filtro, sem_email: false }),
        },
    ].filter(Boolean);

    const excluir = (id) => {
        Alert({
            icon: "error",
            confirmButton: "Sair",
            denyButton: <><FaThumbsUp size={20} /> Excluir</>,
            title: "Excluir",
            callBack: (result) => {
                if (result.isDenied) {
                    api({
                        method: 'delete',
                        action: '/participante/' + id,
                        token: token
                    })
                        .then(function (response) {
                            buscar();
                        })
                        .catch(function (error) {
                            //alert(error)
                        });
                }
            }
        });
    };

    // Cópias de e-mail do formulário: a API guarda listas, a tela edita o texto separado por vírgula.
    const abrirCopias = () => {
        api({ method: 'get', action: '/fornecedor/disparo/copias', token: token })
            .then(response => {
                const dados = response.data.data || {};
                setCopias({
                    recebimento: (dados.emails_copia_recebimento || []).join(', '),
                    envio: (dados.emails_copia_envio || []).join(', '),
                });
            })
            .catch(() => toast.error('Não foi possível carregar as cópias. Tente novamente.'));
    };

    const salvarCopias = () => {
        setSalvandoCopias(true);
        api({
            method: 'put',
            action: '/fornecedor/disparo/copias',
            token: token,
            data: { emails_copia_recebimento: copias.recebimento, emails_copia_envio: copias.envio },
        })
            .then(() => {
                toast.success('Cópias salvas.');
                setCopias(null);
            })
            // O 422 diz qual endereço não fecha; o resto cai na mensagem genérica.
            .catch(error => toast.error(
                error?.response?.status === 422 && error.response.data?.error
                    ? error.response.data.error
                    : 'Não foi possível salvar as cópias. Tente novamente.'
            ))
            .finally(() => setSalvandoCopias(false));
    };

    /**
     * Status do formulário de cadastro. "Sem e-mail" ganha pílula própria porque a
     * ação é outra: não adianta cobrar quem não tem como receber — tem que corrigir
     * o cadastro primeiro.
     */
    const renderFormularioPill = (row) => {
        // Escada do anexo, de cima para baixo: aprovado vence em revisão, que vence
        // enviado. Quem devolveu o formulário saiu da fila de cobrança, e é isso que o
        // operador precisa ler de relance.
        // Data E HORA: o critério de aceitação pede as duas, e a coluna mostrava só
        // a data. Um disparo e a cobrança do mesmo dia ficavam indistinguíveis.
        const dataBr = (v) => {
            if (!v) return '';
            const [data, hora] = String(v).replace('T', ' ').split(' ');
            const [ano, mes, dia] = String(data).split('-');
            if (!ano || !mes || !dia) return String(v);
            return dia + '/' + mes + '/' + ano + (hora ? ' ' + hora.slice(0, 5) : '');
        };

        if (row.status_disparo === 'aprovado') {
            const data = dataBr(row.disparo_aprovado_em);
            return (
                <span className="fin-pp__pill is-ok" title={`Cadastro aplicado em ${data}`}>
                    Aprovado{data ? ` ${data}` : ''}
                </span>
            );
        }

        if (row.status_disparo === 'em_revisao') {
            const data = dataBr(row.disparo_preenchido_em);
            return (
                <span className="fin-pp__pill is-info" title={`Formulário recebido em ${data}`}>
                    Em revisão{data ? ` ${data}` : ''}
                </span>
            );
        }

        if (row.status_disparo === 'gerado') {
            // Deve o formulário como o Enviado, mas o link foi gerado na aba Formulário do
            // cadastro e entregue por fora: não saiu e-mail. Chip e filtro próprios.
            const data = dataBr(row.disparo_link_gerado_em);
            return (
                <span className="fin-pp__pill is-ok" title={`Link gerado${data ? ` em ${data}` : ''}, entregue fora do sistema`}>
                    Link gerado{data ? ` ${data}` : ''}
                </span>
            );
        }

        if (row.status_disparo === 'enviado') {
            // Duas datas distintas, como o item 5 pede: `disparo_enviado_em` é o
            // primeiro envio do ciclo e `disparo_ultima_cobranca` é a última
            // insistência. Elas já vinham separadas do servidor, mas a tela lia só a
            // primeira — e, como ela era o MAX de todos os envios, mostrava a data
            // da cobrança com o rótulo "Enviado em" e perdia a do disparo original.
            const data = dataBr(row.disparo_enviado_em);
            const cobranca = dataBr(row.disparo_ultima_cobranca);
            const titulo = [
                data ? `Enviado em ${data}` : 'Enviado',
                row.disparo_cobrancas > 0
                    ? `${row.disparo_cobrancas} cobrança(s)${cobranca ? `, a última em ${cobranca}` : ''}`
                    : null,
            ].filter(Boolean).join(' · ');

            return (
                <span className="fin-pp__pill is-ok" title={titulo}>
                    Enviado{data ? ` ${data}` : ''}
                    {row.disparo_cobrancas > 0 ? ` (+${row.disparo_cobrancas})` : ''}
                </span>
            );
        }

        if (row.disparo_sem_email) {
            return <span className="fin-pp__pill is-warn">Sem e-mail</span>;
        }

        return <span className="fin-pp__pill is-muted">Não enviado</span>;
    };

    const renderFiscalPill = (row) => {
        const cf = row.classificacao_fiscal;
        if (cf && (cf.nbs || cf.retem_irrf || cf.retem_iss || cf.retem_pis || cf.retem_cofins || cf.retem_csll || cf.retem_inss || cf.retem_ibs || cf.retem_cbs)) {
            return (
                <span
                    className="fin-pp__pill is-ok"
                    title={cf.nbs ? ('NBS: ' + cf.nbs) : 'Classificação fiscal cadastrada'}
                >
                    OK
                </span>
            );
        }
        return (
            <span
                className="fin-pp__pill is-warn"
                title="Fornecedor sem NBS ou retenções cadastradas — financeiro não consegue calcular impostos"
            >
                Pendente
            </span>
        );
    };

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div><h1 className="fin-pp__title">Fornecedores</h1></div>
                    <div className="fin-pp__actions">
                        {!['evento'].includes(perfil) && (
                            <Link
                                to={{ pathname: "/cadastroFornecedor", state: { tipoCadastro: tipoCadastro } }}
                                className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--pill"
                            >
                                <FaPlus size={14} /> Novo Fornecedor
                            </Link>
                        )}
                        <Link to="/hotel" className="fin-pp__btn fin-pp__btn--pill fin-pp__btn--sm">
                            <FaHotel size={14} /> Hotéis
                        </Link>
                        <Link to="/freelancer" className="fin-pp__btn fin-pp__btn--pill fin-pp__btn--sm">
                            <FaUserTie size={14} /> Freelancers
                        </Link>
                        <Link to="/fornecedorGrupo" className="fin-pp__btn fin-pp__btn--pill fin-pp__btn--sm">
                            <FaLayerGroup size={14} /> Grupos
                        </Link>
                        <Link to="/compra" className="fin-pp__btn fin-pp__btn--pill fin-pp__btn--sm">
                            <FaFileInvoiceDollar size={14} /> Faturas
                        </Link>
                        {podeDisparar && (
                            <Link to="/fornecedorDisparo" className="fin-pp__btn fin-pp__btn--pill fin-pp__btn--sm">
                                <FaPaperPlane size={13} /> Disparo de Formulário
                            </Link>
                        )}
                        {podeDisparar && (
                            <Link to="/fornecedorSubmissao" className="fin-pp__btn fin-pp__btn--pill fin-pp__btn--sm">
                                <FaClipboardCheck size={13} /> Revisão de Cadastro
                            </Link>
                        )}
                        {podeDisparar && (
                            <button type="button" className="fin-pp__btn fin-pp__btn--pill fin-pp__btn--sm" onClick={abrirCopias}>
                                <FaEnvelope size={13} /> Cópias de e-mail
                            </button>
                        )}
                    </div>
                </div>

                <form
                    className="fin-pp__card fin-pp__search"
                    style={{ padding: '14px 16px', marginBottom: 12 }}
                    onSubmit={e => {
                        e.preventDefault();
                        // `setPage(1)` sozinho não refaz a busca quando já se está na
                        // página 1; o `recarga` garante que buscar por outro nome
                        // sempre dispare.
                        setPage(1);
                        setRecarga(r => r + 1);
                    }}
                >
                    <div className="fin-pp__search-field">
                        <FaSearch className="fin-pp__search-ic" size={16} />
                        <input
                            id="buscaFornecedor"
                            type="text"
                            className="fin-pp__input"
                            placeholder="Buscar por nome, nome fantasia, código ou CNPJ"
                            value={filtro.nome ?? ''}
                            onChange={e => setFiltro({ ...filtro, nome: e.target.value })}
                        />
                    </div>
                    <button type="submit" className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--tall" disabled={buscando}>
                        <FaSearch size={14} /> Buscar
                    </button>
                    <button type="button" className="fin-pp__btn fin-pp__btn--tall" onClick={abrirFiltros}>
                        <FaFilter size={14} /> Mais filtros{filtrosAtivos.length > 0 ? ` (${filtrosAtivos.length})` : ''}
                    </button>
                </form>

                {filtrosAtivos.length > 0 && (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 12 }}>
                        {filtrosAtivos.map(ativo => (
                            <span key={ativo.chave} className="fin-pp__pill is-info">
                                {ativo.rotulo}
                                <button
                                    type="button"
                                    className="fin-pp__rowbtn"
                                    style={{ marginLeft: 6, width: 18, height: 18 }}
                                    title="Tirar este filtro"
                                    onClick={ativo.limpar}
                                >
                                    <FaTimes size={10} />
                                </button>
                            </span>
                        ))}
                    </div>
                )}

                {mostrarFiltros && rascunho && (
                    <div
                        className="modal fade show d-block fin-pp fin-pp__modalbg"
                        onClick={(e) => { if (e.target === e.currentTarget) setMostrarFiltros(false); }}
                    >
                        <div className="modal-dialog modal-dialog-centered modal-lg">
                            <div className="modal-content fin-pp__modal fin-pp__modal--flow">
                                <div className="fin-pp__modal-head">
                                    <span className="fin-pp__modal-head-ic"><FaFilter size={17} /></span>
                                    <h3 className="fin-pp__modal-title">Filtros avançados
                                        <span className="fin-pp__modal-sub">Refine a lista de fornecedores</span>
                                    </h3>
                                    <button type="button" className="fin-pp__modal-close" onClick={() => setMostrarFiltros(false)}>
                                        <FaTimes size={16} />
                                    </button>
                                </div>
                                <div className="modal-body" style={{ minHeight: 220 }}>
                                    <div className="fin-pp__filters">
                                        <FinField label="Grupos" full>
                                            <ReactSelect
                                                placeholder="Busque pelo nome do grupo"
                                                loadOptions={buscarGrupos}
                                                isMulti
                                                value={rascunho.grupos}
                                                onChange={opcoes => setRascunho({ ...rascunho, grupos: opcoes || [] })}
                                                isClearable
                                            />
                                            {rascunho.grupos.length > 1 && (
                                                <FinChecks style={{ marginTop: 8 }}>
                                                    <FinCheck
                                                        id="fornecedorGrupoTodos"
                                                        label="Só fornecedores que estão em todos os grupos selecionados"
                                                        checked={rascunho.fornecedorGrupoTodos}
                                                        onChange={e => setRascunho({ ...rascunho, fornecedorGrupoTodos: e.target.checked })}
                                                    />
                                                </FinChecks>
                                            )}
                                        </FinField>
                                        <FinField label="Situação" grow>
                                            <ReactSelect
                                                options={OPCOES_SITUACAO}
                                                value={{ value: rascunho.situacaoRegistro }}
                                                onChange={e => setRascunho({ ...rascunho, situacaoRegistro: e ? e.value : 'ativo' })}
                                            />
                                        </FinField>
                                        <FinField label="Preferencial" grow>
                                            <ReactSelect
                                                options={OPCOES_PREFERENCIAL}
                                                value={{ value: rascunho.preferencial }}
                                                onChange={e => setRascunho({ ...rascunho, preferencial: e ? e.value : 'todos' })}
                                            />
                                        </FinField>
                                    </div>
                                    {/* Épico 0 — Filtro "sem classificação fiscal" (auditoria Katia) */}
                                    <FinChecks style={{ marginTop: 12 }}>
                                        <FinCheck
                                            id="sem_classificacao_fiscal"
                                            label="Só fornecedores sem classificação fiscal (sem NBS ou retenções cadastradas)"
                                            checked={rascunho.sem_classificacao_fiscal}
                                            onChange={e => setRascunho({ ...rascunho, sem_classificacao_fiscal: e.target.checked })}
                                        />
                                        <FinCheck
                                            id="sem_email"
                                            label="Só fornecedores sem e-mail (nem no cadastro, nem em contatos) — não têm como receber o formulário"
                                            checked={rascunho.sem_email}
                                            onChange={e => setRascunho({ ...rascunho, sem_email: e.target.checked })}
                                        />
                                    </FinChecks>
                                </div>
                                <div className="fin-pp__modal-foot">
                                    <button type="button" className="fin-pp__btn" onClick={limparRascunho}>
                                        Limpar filtros
                                    </button>
                                    <button type="button" className="fin-pp__btn fin-pp__btn--primary" onClick={aplicarFiltros}>
                                        <FaSearch size={14} /> Aplicar filtros
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {copias && (
                    <div
                        className="modal fade show d-block fin-pp fin-pp__modalbg"
                        onClick={(e) => { if (e.target === e.currentTarget) setCopias(null); }}
                    >
                        <div className="modal-dialog modal-dialog-centered modal-lg">
                            <div className="modal-content fin-pp__modal">
                                <div className="fin-pp__modal-head">
                                    <span className="fin-pp__modal-head-ic"><FaEnvelope size={17} /></span>
                                    <h3 className="fin-pp__modal-title">Cópias de e-mail
                                        <span className="fin-pp__modal-sub">Quem recebe em cópia os e-mails do formulário de cadastro</span>
                                    </h3>
                                    <button type="button" className="fin-pp__modal-close" onClick={() => setCopias(null)}>
                                        <FaTimes size={16} />
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="fin-pp__filters">
                                        <FinField
                                            label="Cópia na confirmação de recebimento"
                                            ajuda="Recebe cada confirmação de que um fornecedor enviou o formulário, inclusive pelo link gerado."
                                            full
                                        >
                                            <FinTextarea
                                                rows={2}
                                                placeholder="email@empresa.com, outro@empresa.com"
                                                value={copias.recebimento}
                                                onChange={e => setCopias({ ...copias, recebimento: e.target.value })}
                                            />
                                        </FinField>
                                        <FinField
                                            label="Cópia no envio do formulário"
                                            ajuda="Recebe em cópia cada e-mail com o link do formulário: disparo, pedido de atualização e lembretes."
                                            full
                                        >
                                            <FinTextarea
                                                rows={2}
                                                placeholder="email@empresa.com, outro@empresa.com"
                                                value={copias.envio}
                                                onChange={e => setCopias({ ...copias, envio: e.target.value })}
                                            />
                                        </FinField>
                                    </div>
                                    <p style={{ fontSize: 12, color: 'var(--fin-mt)', margin: '10px 0 0' }}>
                                        Separe os e-mails por vírgula. Os dois campos podem ficar vazios.
                                    </p>
                                </div>
                                <div className="fin-pp__modal-foot">
                                    <button type="button" className="fin-pp__btn" onClick={() => setCopias(null)}>
                                        Cancelar
                                    </button>
                                    <button type="button" className="fin-pp__btn fin-pp__btn--primary" disabled={salvandoCopias} onClick={salvarCopias}>
                                        Salvar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Os chips contam o universo ATIVO do tenant (`statusFornecedores`
                    filtra `situacaoRegistro = ativo`), então fora dessa faixa eles
                    descreveriam outra população que não a da lista — que é a
                    divergência "o chip diz um número, clicar nele traz outro". Some
                    com eles em vez de tentar reconciliar: disparo não se aplica a
                    fornecedor desligado. */}
                {contadoresDisparo && filtro.situacaoRegistro === 'ativo' && (
                    <div className="fin-pp__statusbar" style={{ flexWrap: 'wrap', gap: 8, marginBottom: 12 }}>
                        {[
                            { valor: '', rotulo: 'Todos', quantidade: contadoresDisparo.total },
                            { valor: 'nao_enviado', rotulo: 'Não enviados', quantidade: contadoresDisparo.nao_enviado },
                            // As faixas são excludentes e somam o total — ver o
                            // StatusFormulario. "Enviados" é quem recebeu por e-mail e
                            // AINDA DEVE o formulário.
                            { valor: 'enviado', rotulo: 'Enviados', quantidade: contadoresDisparo.enviado },
                            // Também deve o formulário, mas recebeu o link por fora: gerado na
                            // aba Formulário do cadastro, sem e-mail do sistema.
                            { valor: 'gerado', rotulo: 'Links gerados', quantidade: contadoresDisparo.gerado ?? 0 },
                            // "Preenchido" e "Em revisão" do anexo são o MESMO instante:
                            // devolver o formulário É entrar na fila. Os chips mostram as
                            // faixas que de fato particionam; o filtro `preenchido` segue
                            // aceito no back e vale a união destas duas.
                            { valor: 'em_revisao', rotulo: 'Em revisão', quantidade: contadoresDisparo.em_revisao },
                            { valor: 'aprovado', rotulo: 'Aprovados', quantidade: contadoresDisparo.aprovado },
                        ].map(chip => (
                            <button
                                key={chip.valor || 'todos'}
                                type="button"
                                className="fin-pp__statuschip"
                                onClick={() => setFiltro({ ...filtro, status_disparo: chip.valor })}
                                title={`${chip.quantidade} fornecedor(es)`}
                                style={{
                                    cursor: 'pointer',
                                    background: (filtro.status_disparo ?? '') === chip.valor ? 'var(--fin-acw)' : 'transparent',
                                    borderColor: (filtro.status_disparo ?? '') === chip.valor ? 'var(--fin-acb)' : 'var(--fin-bd)',
                                    color: (filtro.status_disparo ?? '') === chip.valor ? 'var(--fin-ac)' : 'var(--fin-mt)',
                                }}
                            >
                                <span className="fin-pp__statuschip-num">{chip.quantidade}</span>
                                <span>{chip.rotulo}</span>
                            </button>
                        ))}
                        <span style={{ alignSelf: 'center', fontSize: 12, color: 'var(--fin-mt)' }}>
                            formulário de cadastro · {contadoresDisparo.sem_email} sem e-mail
                        </span>
                    </div>
                )}

                {selectedArr.length > 0 && (
                    <div className="fin-pp__bulkbar" style={{ marginBottom: 8 }}>
                        <span className="fin-pp__bulkbar-count">{selectedArr.length} selecionado(s)</span>
                        <div className="fin-pp__bulkbar-actions">
                            {/* Levam a seleção para a tela do disparo em vez de abrir um
                                modal próprio: a confirmação já existe lá, e é lá que fica
                                a barra de progresso — que é onde o operador precisa estar
                                depois de disparar. */}
                            {/* Mesma lista do disparo no back, que tem o `suplier`, como o
                                Excluir logo abaixo. O servidor tem a trava
                                própria; esta aqui só evita o clique. */}
                            {podeDisparar && (
                                <>
                                    <button
                                        type="button"
                                        className="fin-pp__btn fin-pp__btn--sm"
                                        onClick={() => history.push('/fornecedorDisparo', { alvos: selectedArr })}
                                    >
                                        <FaPaperPlane size={12} /> Enviar formulário
                                    </button>
                                    <button
                                        type="button"
                                        className="fin-pp__btn fin-pp__btn--sm"
                                        onClick={() => history.push('/fornecedorDisparo', { alvos: selectedArr, cobranca: true })}
                                    >
                                        <FaRedo size={12} /> Cobrar
                                    </button>
                                    {/* O espelho do Cobrar. Cobrar mira quem recebeu e NÃO
                                        entregou; este mira quem JÁ entregou, para pedir o
                                        cadastro de novo — a revisão periódica. Sem ele o
                                        recorte só saía por uma corrente de duas caixas
                                        dentro do modal, que o operador descobria por
                                        tentativa. Quem não preencheu é descartado no
                                        servidor, então marcar linhas demais não vira
                                        e-mail indevido. */}
                                    <button
                                        type="button"
                                        className="fin-pp__btn fin-pp__btn--sm"
                                        onClick={() => history.push('/fornecedorDisparo', { alvos: selectedArr, revisao: true })}
                                    >
                                        <FaSyncAlt size={12} /> Pedir atualização
                                    </button>
                                </>
                            )}
                            {selectedArr.length === 1 && ['admin', 'diretor', 'gerenteprojeto', 'gerentefinanceiro', 'suplier'].includes(perfil) && (
                                <button
                                    type="button"
                                    className="fin-pp__btn fin-pp__btn--danger fin-pp__btn--sm"
                                    onClick={() => excluir(selectedArr[0])}
                                >
                                    <ImCancelCircle size={14} /> Excluir
                                </button>
                            )}
                        </div>
                    </div>
                )}

                <div className="fin-pp__card" style={{ overflow: 'hidden' }}>
                    <div className="fin-pp__tblwrap">
                        <table className="fin-pp__tbl" style={{ tableLayout: 'auto' }}>
                            <thead>
                                <tr>
                                    <th style={{ width: 40 }}>
                                        <input
                                            type="checkbox"
                                            checked={paginaToda()}
                                            onChange={toggleAll}
                                        />
                                    </th>
                                    {!['evento'].includes(perfil) && <th style={{ width: 60 }}></th>}
                                    <th className="is-sortable" onClick={() => ordenarPor('situacao')}>Situação{seta('situacao')}</th>
                                    <th className="is-sortable" onClick={() => ordenarPor('preferencial')}>Preferencial{seta('preferencial')}</th>
                                    <th className="is-sortable" onClick={() => ordenarPor('codigo')}>Código{seta('codigo')}</th>
                                    <th className="is-sortable" onClick={() => ordenarPor('nome')}>Nome{seta('nome')}</th>
                                    <th className="is-sortable" onClick={() => ordenarPor('fiscal')}>Fiscal{seta('fiscal')}</th>
                                    <th className="is-sortable" onClick={() => ordenarPor('formulario')}>Formulário{seta('formulario')}</th>
                                    <th className="is-sortable" onClick={() => ordenarPor('grupo')}>Grupo{seta('grupo')}</th>
                                    <th className="is-sortable" onClick={() => ordenarPor('municipio')}>Município{seta('municipio')}</th>
                                    <th className="is-sortable" onClick={() => ordenarPor('documento')}>CNPJ/CPF{seta('documento')}</th>
                                    <th className="is-sortable" onClick={() => ordenarPor('nomefantasia')}>Nome Fantasia{seta('nomefantasia')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {buscando
                                    ? <tr><td colSpan={12} className="fin-pp__empty" style={{ padding: 0 }}><TabelaLoading /></td></tr>
                                    : paginados.length === 0
                                        ? <tr><td colSpan={12} className="fin-pp__empty">Nenhum registro</td></tr>
                                        : paginados.map(row => (
                                            <tr key={row.id}>
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedIds.has(row.id)}
                                                        onChange={() => toggleSelect(row.id)}
                                                    />
                                                </td>
                                                {!['evento'].includes(perfil) && (
                                                    <td>
                                                        <Link
                                                            to={{ pathname: '/cadastroFornecedor/' + row.id, state: { tipoCadastro: tipoCadastro } }}
                                                            className="fin-pp__rowbtn"
                                                        >
                                                            <FaPen size={14} />
                                                        </Link>
                                                    </td>
                                                )}
                                                <td>
                                                    <span className={`fin-pp__pill ${row.situacaoRegistro === 'ativo' ? 'is-ok' : 'is-muted'}`}>
                                                        {row.situacaoRegistro ?? ''}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className={`fin-pp__pill ${row.preferencial === 'sim' ? 'is-ok' : 'is-muted'}`}>
                                                        {row.preferencial === 'sim' ? 'sim' : 'não'}
                                                    </span>
                                                </td>
                                                <td className="fin-pp__cell-muted">{row.codigo ?? ''}</td>
                                                <td className="fin-pp__cell-strong">{row.nome ?? ''}</td>
                                                <td>{renderFiscalPill(row)}</td>
                                                <td>{renderFormularioPill(row)}</td>
                                                <td className="fin-pp__cell-muted">
                                                    {(row.fornecedorgrupos ?? []).length > 0
                                                        ? row.fornecedorgrupos.map((grupo, indice) => (
                                                            <span key={grupo.id} style={{ display: 'inline-flex', alignItems: 'center', gap: 4, marginRight: 6 }}>
                                                                {linkGrupo(grupo)}{indice < row.fornecedorgrupos.length - 1 ? ',' : ''}
                                                                <AlertaSedes sedes={grupo.sedes} grupoId={podeVerGrupo ? grupo.id : undefined} />
                                                            </span>
                                                        ))
                                                        : (row.fornecedorgrupo ? linkGrupo(row.fornecedorgrupo) : '')}
                                                </td>
                                                <td className="fin-pp__cell-muted">
                                                    {row.enderecomunicipio ? row.enderecomunicipio.nome + '-' + row.enderecomunicipio.uf : ''}
                                                </td>
                                                <td className="fin-pp__cell-muted">
                                                    {row.cnpj !== '' ? <div>{row.cnpj}</div> : null}
                                                    {row.cpf !== '' ? <div>{row.cpf}</div> : null}
                                                </td>
                                                <td className="fin-pp__cell-muted">{row.nomefantasia ?? ''}</td>
                                            </tr>
                                        ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="fin-pp__pagination">
                        <div className="fin-pp__pagination-info">{total} registros</div>
                        <div className="fin-pp__pagination-ctrls">
                            <select
                                className="fin-pp__select"
                                style={{ height: 34 }}
                                value={pageSize}
                                onChange={e => { setPageSize(Number(e.target.value)); setPage(1); }}
                            >
                                <option value={15}>15 / pág</option>
                                <option value={30}>30 / pág</option>
                                <option value={50}>50 / pág</option>
                            </select>
                            <button className="fin-pp__btn fin-pp__btn--sm" disabled={page <= 1} onClick={() => setPage(p => p - 1)}>Anterior</button>
                            <span className="fin-pp__pagination-info">{page} / {totalPaginas}</span>
                            <button className="fin-pp__btn fin-pp__btn--sm" disabled={page >= totalPaginas} onClick={() => setPage(p => p + 1)}>Próxima</button>
                        </div>
                    </div>
                </div>
            </div>
        </ErpTemplate>
    );
}
